import {ImplementedAntibodySchemaInterface} from 'antibodies/hooks/useImplementedAntibodySchemaInterfacesQuery';

export interface FormatSchemaUsage {
  count: number;
  schemaNames: Array<string>;
}

export type FormatSchemaUsageMap = Map<string, FormatSchemaUsage>;

/**
 * Builds a map from format ID to the count and names of non-archived schemas
 * that use each format. Schemas are deduplicated by ID and names are sorted
 * alphabetically.
 */
export function buildFormatSchemaUsageMap(
  implementedInterfaces: Array<ImplementedAntibodySchemaInterface>
): FormatSchemaUsageMap {
  const formatToSchemas = new Map<string, Map<string, string>>();

  for (const impl of implementedInterfaces) {
    if (impl.schema.archived) {
      continue;
    }

    const formatId = impl.format.id;
    if (!formatToSchemas.has(formatId)) {
      formatToSchemas.set(formatId, new Map());
    }
    formatToSchemas.get(formatId)!.set(impl.schema.id, impl.schema.name);
  }

  const result: FormatSchemaUsageMap = new Map();
  for (const [formatId, schemasById] of formatToSchemas) {
    const schemaNames = [...schemasById.values()].sort((a, b) => a.localeCompare(b));
    result.set(formatId, {count: schemaNames.length, schemaNames});
  }

  return result;
}
